import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-749f453a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-left px-3 pt-3" }
const _hoisted_2 = { class: "text-subtitle-1 font-weight-bold mb-2" }
const _hoisted_3 = {
  key: 0,
  class: "text-center pa-4"
}
const _hoisted_4 = {
  key: 1,
  class: "text-center pa-4"
}
const _hoisted_5 = {
  key: 2,
  class: "text-center text-medium-emphasis pa-4"
}
const _hoisted_6 = { class: "d-flex align-center ga-2" }
const _hoisted_7 = { class: "text-body-1 font-weight-bold flex-grow-1 nick" }
const _hoisted_8 = {
  key: 0,
  class: "text-caption text-medium-emphasis email"
}
const _hoisted_9 = { class: "d-flex align-center ga-2" }
const _hoisted_10 = { class: "text-body-2 flex-grow-1" }
const _hoisted_11 = {
  key: 0,
  class: "text-medium-emphasis text-no-wrap"
}
const _hoisted_12 = { class: "text-caption text-medium-emphasis" }

import { useTorneoCerrado } from "@/composables/useTorneoCerrado";
import { esUsuarioBye } from "@/utils/bye";
import { bandoLista, estadoLista } from "@/utils/estadoLista";
import { ref, computed, watch } from "vue";

import ModalDetalleInscripcion from "./ModalDetalleInscripcion.vue";
import {
  InscripcionTorneoCreadoDTO,
  TorneoGestionInfoDTO,
} from "@/interfaces/Torneo";
import ModalParametrosPrimeraRonda from "./ModalParametrosPrimeraRonda.vue";
import ModalAddJugadorTorneo from "./ModalAddJugadorTorneo.vue";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import { getInfoTorneoCreado } from "@/services/TorneosService";
import ModalSorteo from "./ModalSorteo.vue";
import PuntosExtra from "./PuntosExtra.vue";
import InterruptorPago from "./InterruptorPago.vue";
import { ClassificationType } from "@/Constant/TipoClasificacion";


export default /*#__PURE__*/_defineComponent({
  __name: 'TablaInscritos',
  props: {
    torneo: {}
  },
  emits: ["inscripcionEliminada", "puntosExtra"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
// Cerrado, ya no entra ni sale nadie
const cerrado = useTorneoCerrado();
const localInscripciones = ref<InscripcionTorneoCreadoDTO[]>([]);
const isLoading = ref<boolean>(true);
const showConfigModal = ref<boolean>(false);
const showSorteoModal = ref<boolean>(false);
const showAddJugadorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const localTorneo = ref<TorneoGestionInfoDTO>();
const nicks = ref<string[]>();

const openConfigModal = async () => {
  isLoading.value = true;
  try {
    if (props.torneo?.torneo.idTorneo) {
      const responseTorneo = await getInfoTorneoCreado(
        props.torneo?.torneo.idTorneo
      );
      localTorneo.value = responseTorneo.data;
    }
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
  showConfigModal.value = true;
};

const openSorteo = async () => {
  isLoading.value = true;
  try {
    // El bye no entra en el sorteo
    nicks.value = localInscripciones.value
      .filter((x) => !esBye(x))
      .map((x) => x.nick)
      .filter((nick): nick is string => nick !== null && nick !== undefined);
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
  showSorteoModal.value = true;
};

const closeSorteoModal = () => {
  showSorteoModal.value = false;
};

const openAddJugadorModal = async () => {
  await props.torneo;
  showAddJugadorModal.value = true;
};

const closeConfigModal = () => {
  showConfigModal.value = false;
  window.location.reload();
};

const closeAddJugadorModal = () => {
  showAddJugadorModal.value = false;
};

const handleConfigConfirm = () => {
  closeConfigModal();
};

const handleAddJugadorConfirm = () => {
  showAddJugadorModal.value = false;
  showSuccessModal.value = false;
  window.location.reload();
};

watch(
  () => props.torneo?.inscripciones,
  (newInscripciones) => {
    if (newInscripciones) {
      localInscripciones.value = [...newInscripciones];
    }
    isLoading.value = false;
  },
  { immediate: true }
);

watch(
  () => showSuccessModal.value,
  (newValue) => {
    if (!newValue) {
      window.location.reload();
    }
  }
);

const emit = __emit;

// Generar la ronda 1 y el sorteo se piden desde la tarjeta de gestión, debajo de Descargar listas
__expose({ abrirGenerarRonda1: openConfigModal, abrirSorteo: openSorteo });

const search = ref<string | null>("");
const showModal = ref(false);
const selectedInscripcion = ref<InscripcionTorneoCreadoDTO>({
  idInscripcion: 0,
  idUsuario: 0,
  torneo: {
    idTorneo: 0,
    idUsuario: 0,
    nombreTorneo: "",
    descripcionTorneo: "",
    fechaInicioTorneo: "",
    fechaFinTorneo: "",
    precioTorneo: 0,
    numeroPartidas: 0,
    puntosTorneo: 0,
    estadoTorneo: "ESPERANDO",
    lugarTorneo: "",
    esPrivadoTorneo: false,
    idRangoTorneo: 0,
    esMatchedPlayTorneo: false,
    fechaEntregaListas: "",
    fechaFinInscripcion: "",
    basesTorneo: "",
    cartelTorneo: "",
    metodosPago: [],
    horaInicioTorneo: "",
    horaFinTorneo: "",
    tieneBases: false,
    inicioInscripciones: "",
    listasPorJugador: 0,
    tipoTorneo: "Individual",
    mostrarListas: false,
    mostrarClasificacion: false,
    classificationType: ClassificationType.NORMAL
  },
  idTorneo: 0,
  puntosExtra: 0,
});

// Filtros: a quien le falta la lista (sin entregar o ilegal, que hay que cambiar), solo los de lista ilegal y los que
// no han pagado
const filtro = ref<"todos" | "faltanListas" | "ilegal" | "sinPagar">("todos");
const estaPagado = (item: InscripcionTorneoCreadoDTO) => (item.esPago ?? "").toUpperCase() === "SI";
const faltaLista = (item: InscripcionTorneoCreadoDTO) =>
  !["ENTREGADA", "OK"].includes((item.estadoLista ?? "").toUpperCase());
// El bye lo inscribe el sistema con números impares: no es nadie a quien reclamar nada
const esBye = (item: InscripcionTorneoCreadoDTO) => esUsuarioBye(item.idUsuario, item.nick);
const reales = computed(() => localInscripciones.value.filter(i => !esBye(i)));
const faltanListas = computed(() => reales.value.filter(faltaLista));
const ilegales = computed(() =>
  reales.value.filter(i => (i.estadoLista ?? "").toUpperCase() === "ILEGAL")
);
const sinPagar = computed(() => reales.value.filter(i => !estaPagado(i)));
const normalizar = (texto: string) =>
  texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
const visibles = computed(() => {
  const base =
    filtro.value === "faltanListas"
      ? faltanListas.value
      : filtro.value === "ilegal"
        ? ilegales.value
        : filtro.value === "sinPagar"
          ? sinPagar.value
          : localInscripciones.value;
  const texto = normalizar(search.value ?? "").trim();
  return texto ? base.filter(i => normalizar(i.nick ?? "").includes(texto)) : base;
});
// Fuera de plazo: después de la fecha límite del torneo
const tarde = (fecha?: string | null, limite?: string | null) =>
  !!fecha && !!limite && new Date(fecha) > new Date(limite);

const formattedDate = (date: string | null | undefined) => {
  return date ? new Date(date).toLocaleDateString() : "N/A";
};


const handleRowClick = (item: InscripcionTorneoCreadoDTO) => {
  selectedInscripcion.value = item;
  showModal.value = true;
};

const handleUpdateInscripcion = (payload: {
  field: keyof InscripcionTorneoCreadoDTO;
  value: any;
}) => {
  if (selectedInscripcion.value) {
    (selectedInscripcion.value[payload.field] as unknown) = payload.value;
  }
};

const handleEliminarInscripcion = (idInscripcion: number) => {
  const index = localInscripciones.value.findIndex(
    (inscripcion) => inscripcion.idInscripcion === idInscripcion
  );
  if (index !== -1) {
    localInscripciones.value.splice(index, 1);
    emit("inscripcionEliminada", idInscripcion);
  }
};

const closeModal = () => {
  showModal.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, { flat: "" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (!_unref(cerrado))
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                variant: "tonal",
                color: "secondary",
                block: "",
                class: "mb-3",
                onClick: openAddJugadorModal
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Añadir jugador ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("h3", _hoisted_2, "Inscritos (" + _toDisplayString(reales.value.length) + ")", 1),
          _createVNode(_component_v_text_field, {
            modelValue: search.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
            density: "compact",
            label: "Buscar jugador",
            "prepend-inner-icon": "mdi-magnify",
            clearable: "",
            "hide-details": "",
            class: "mb-2"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_chip_group, {
            modelValue: filtro.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filtro).value = $event)),
            mandatory: "",
            column: "",
            "selected-class": "text-primary",
            class: "mb-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_chip, {
                value: "todos",
                size: "small",
                filter: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Todos (" + _toDisplayString(reales.value.length) + ")", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_chip, {
                value: "faltanListas",
                size: "small",
                filter: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Faltan listas (" + _toDisplayString(faltanListas.value.length) + ")", 1)
                ]),
                _: 1
              }),
              (ilegales.value.length > 0)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 0,
                    value: "ilegal",
                    size: "small",
                    filter: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Lista ilegal (" + _toDisplayString(ilegales.value.length) + ") ", 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_chip, {
                value: "sinPagar",
                size: "small",
                filter: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("No pagado (" + _toDisplayString(sinPagar.value.length) + ")", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Cargando inscripciones..."))
          : (localInscripciones.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " No hay inscripciones para este torneo "))
            : (visibles.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Nadie con estos filtros "))
              : (_openBlock(), _createBlock(_component_v_row, {
                  key: 3,
                  dense: "",
                  class: "px-2"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibles.value, (item) => {
                      return (_openBlock(), _createBlock(_component_v_col, {
                        key: item.idInscripcion,
                        cols: "12",
                        sm: "6",
                        lg: "4"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createBlock(_component_v_card, {
                            variant: "outlined",
                            class: "pa-3 text-left tarjeta",
                            role: "button",
                            tabindex: "0",
                            onClick: ($event: any) => (handleRowClick(item)),
                            onKeydown: _withKeys(($event: any) => (handleRowClick(item)), ["enter"])
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("span", _hoisted_7, _toDisplayString(item.nick), 1),
                                _createVNode(PuntosExtra, {
                                  inscripcion: item,
                                  onCambiado: _cache[2] || (_cache[2] = (idUsuario, puntos) => emit('puntosExtra', idUsuario, puntos))
                                }, null, 8, ["inscripcion"])
                              ]),
                              (item.email)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item.email), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(`text-${_unref(estadoLista)(item.estadoLista).color}`)
                                  }, _toDisplayString(_unref(estadoLista)(item.estadoLista).texto), 3),
                                  (_unref(bandoLista)(item.bando))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, " · " + _toDisplayString(_unref(bandoLista)(item.bando)!.texto), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(InterruptorPago, {
                                  esPago: item.esPago,
                                  idInscripcion: item.idInscripcion,
                                  onCambiado: esPago => (item.esPago = esPago)
                                }, null, 8, ["esPago", "idInscripcion", "onCambiado"])
                              ]),
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("span", {
                                  class: _normalizeClass({ 'text-warning': tarde(item.fechaInscripcion, _ctx.torneo?.torneo.fechaFinInscripcion) })
                                }, " Inscrito " + _toDisplayString(formattedDate(item.fechaInscripcion)), 3),
                                (item.fechaEntrega)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(" · "),
                                      _createElementVNode("span", {
                                        class: _normalizeClass({ 'text-warning': tarde(item.fechaEntrega, _ctx.torneo?.torneo.fechaEntregaListas) })
                                      }, " Lista " + _toDisplayString(formattedDate(item.fechaEntrega)), 3)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onClick", "onKeydown"])), [
                            [_directive_ripple]
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })),
        _createVNode(ModalParametrosPrimeraRonda, {
          isVisible: showConfigModal.value,
          torneo: _ctx.torneo,
          onClose: closeConfigModal,
          onConfirm: handleConfigConfirm
        }, null, 8, ["isVisible", "torneo"]),
        _createVNode(ModalAddJugadorTorneo, {
          isVisible: showAddJugadorModal.value,
          torneo: _ctx.torneo,
          onClose: closeAddJugadorModal,
          onConfirm: handleAddJugadorConfirm
        }, null, 8, ["isVisible", "torneo"]),
        _createVNode(ModalSorteo, {
          isVisible: showSorteoModal.value,
          participantes: nicks.value,
          onClose: closeSorteoModal
        }, null, 8, ["isVisible", "participantes"])
      ]),
      _: 1
    }),
    (showModal.value)
      ? (_openBlock(), _createBlock(ModalDetalleInscripcion, {
          key: 0,
          inscripcion: selectedInscripcion.value,
          onClose: closeModal,
          onUpdateInscripcion: handleUpdateInscripcion,
          onEliminarInscripcion: handleEliminarInscripcion
        }, null, 8, ["inscripcion"]))
      : _createCommentVNode("", true),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Jugador añadido correctamente.",
      "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"])
  ], 64))
}
}

})